import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { FormattedHTMLMessage } from 'react-intl'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

export default ({ modal, toggleModal }) => {
  // Generate a unique ID for the modal to connect aria attributes
  const modalId = 'unsupported-os-error-modal'
  const titleId = 'unsupported-os-error-title'

  return (
    <Modal
      isOpen={modal}
      toggle={toggleModal}
      size="lg"
      centered
      id={modalId}
      aria-labelledby={titleId}
      role="dialog"
    >
      <ModalHeader toggle={toggleModal}>
        <span className="sr-only">
          <FormattedMessage id="global.label.close" defaultMessage="Close" />
        </span>
      </ModalHeader>
      <ModalBody>
        <h2 id={titleId} className="text-center">
          <FormattedMessage id="global.label.error" />
        </h2>
        <p>
          <FormattedHTMLMessage id="error.pvt.unsupportOS" />
        </p>
        <p>
          <small>
            <FormattedMessage id="error.global.footerText" />
            <br />
            <a href="/support" aria-label="Contact support for assistance">
              <FormattedHTMLMessage id="error.global.footerLink" />
            </a>
          </small>
        </p>
      </ModalBody>
      <ModalFooter>
        <div className="w-100">
          <div className="row">
            <div className="col">
              <Button
                block
                outline
                color="danger"
                onClick={toggleModal}
                aria-label="Close this message"
              >
                <FormattedMessage id="global.label.popoverClose" />
              </Button>
            </div>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}
